import { useEffect, useReducer, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import * as Action from "../../../../../store/redux_computer_base/admin_computer_base_reducer.js";

export default function SettingExamsComp({ setLoading }) {
  const [optionType, setoptionType] = useState("Change Option Type");
  const [showDropdown, setShowDropdown] = useState(false);
  const dispatch = useDispatch();
  const active = useSelector((state) => state.adminAssesment);
  console.log(active);

  const [quesionData, setQuesionData] = useReducer(
    (states, payload) => {
      return { ...states, ...payload };
    },
    {
      question: "",
      test: "Bissmillah",
      options: {
        boolean: { key: "True", value: true, key: "False", value: false },
        yesOrNo: {
          key: "Yes",
          value: "Yes",
          key: "No",
          value: "No",
        },
        alphabet2: {
          key: "A",
          value: "",
          key: "B",
          value: "",
        },
        alphabet3: {
          key: "A",
          value: "",
          key: "B",
          value: "",
          key: "C",
          value: "",
        },
        alphabet4: {
          key: "A",
          value_A: "TESTE",
          key: "B",
          value_B: "Trying something",
          key: "C",
          value_C: "",
          key: "D",
          value_D: "",
        },
        alphabet5: {
          key: "A",
          value: "",
          key: "B",
          value: "",
          key: "C",
          value: "",
          key: "D",
          value: "",
          key: "E",
          value: "",
        },
      },
    }
  );

  function ExamsOptionBoolean() {
    return (
      <div className="fx-cl">
        <span>True</span>
        <span>False</span>
      </div>
    );
  }
  function ExamsOptionYesorNo() {
    return (
      <div className="fx-cl">
        <span>Yes</span>
        <span>No</span>
      </div>
    );
  }
  function ExamsOption2() {
    return (
      <div className="fx-cl space1 examsOptionCont">
        <div className="examsOptionComp g g2">
          <span>A</span>
          <textarea
            name="optionExams"
            id=""
            cols="30"
            rows="2"
            value={quesionData.options.boolean}
            onChange={(event) =>
              setQuesionData({ options: { boolean: event.target.value } })
            }
          ></textarea>
        </div>
        <div className="examsOptionComp g g2">
          <span>B</span>
          <textarea
            name="optionExams"
            id=""
            cols="30"
            rows="2"
            value={quesionData.options.boolean}
            onChange={(event) =>
              setQuesionData({ options: { boolean: event.target.value } })
            }
          ></textarea>
        </div>
      </div>
    );
  }
  function ExamsOption3() {
    return (
      <div className="fx-cl space1 examsOptionCont">
        <div className="examsOptionComp g g2">
          <span>A</span>
          <textarea
            name="optionExams"
            id=""
            cols="30"
            rows="2"
            value={quesionData.options.boolean}
            onChange={(event) =>
              setQuesionData({ options: { boolean: event.target.value } })
            }
          ></textarea>
        </div>
        <div className="examsOptionComp g g2">
          <span>B</span>
          <textarea
            name="optionExams"
            id=""
            cols="30"
            rows="2"
            value={quesionData.options.boolean}
            onChange={(event) =>
              setQuesionData({ options: { boolean: event.target.value } })
            }
          ></textarea>
        </div>
        <div className="examsOptionComp g g2">
          <span>C</span>
          <textarea
            name="optionExams"
            id=""
            cols="30"
            rows="2"
            value={quesionData.options.boolean}
            onChange={(event) =>
              setQuesionData({ options: { boolean: event.target.value } })
            }
          ></textarea>
        </div>
      </div>
    );
  }
  function ExamsOption4() {
    return (
      <div className="fx-cl space1 examsOptionCont">
        <div className="examsOptionComp g g2">
          <span>A</span>
          <textarea
            name="optionExams"
            id=""
            cols="30"
            rows="2"
            value={quesionData.test}
            onChange={(event) => setQuesionData({ test: event.target.value })}
          ></textarea>
        </div>
        <div className="examsOptionComp g g2">
          <span>B</span>
          <textarea
            name="optionExams"
            id=""
            cols="30"
            rows="2"
            value={quesionData.options.alphabet4.value_B}
            onChange={(event) =>
              setQuesionData((prevState) => ({
                ...prevState,
                options: {
                  ...prevState.options,
                  alphabet4: {
                    ...prevState.options.alphabet4,
                    value_B: event.target.value,
                  },
                },
              }))
            }
          ></textarea>
        </div>
        <div className="examsOptionComp g g2">
          <span>C</span>
          <textarea
            name="optionExams"
            id=""
            cols="30"
            rows="2"
            value={quesionData.options.alphabet4.value_C}
            onChange={(event) =>
              setQuesionData((prevState) => ({
                ...prevState,
                options: {
                  ...prevState.options,
                  alphabet4: {
                    ...prevState.options.alphabet4,
                    value_C: event.target.value,
                  },
                },
              }))
            }
          ></textarea>
        </div>
        <div className="examsOptionComp g g2">
          <span>D</span>
          <textarea
            name="optionExams"
            id=""
            cols="30"
            rows="2"
            value={quesionData.options.alphabet4.value_D}
            onChange={(event) =>
              setQuesionData((prevState) => ({
                ...prevState,
                options: {
                  ...prevState.options,
                  alphabet4: {
                    ...prevState.options.alphabet4,
                    value_D: event.target.value,
                  },
                },
              }))
            }
          ></textarea>
        </div>
      </div>
    );
  }
  function ExamsOption5() {
    return (
      <div className="fx-cl space1 examsOptionCont">
        <div className="examsOptionComp g g2">
          <span>A</span>
          <textarea
            name="optionExams"
            id=""
            cols="30"
            rows="2"
            value={quesionData.options.boolean}
            onChange={(event) =>
              setQuesionData({ options: { boolean: event.target.value } })
            }
          ></textarea>
        </div>
        <div className="examsOptionComp g g2">
          <span>B</span>
          <textarea
            name="optionExams"
            id=""
            cols="30"
            rows="2"
            value={quesionData.options.boolean}
            onChange={(event) =>
              setQuesionData({ options: { boolean: event.target.value } })
            }
          ></textarea>
        </div>
        <div className="examsOptionComp g g2">
          <span>C</span>
          <textarea
            name="optionExams"
            id=""
            cols="30"
            rows="2"
            value={quesionData.options.boolean}
            onChange={(event) =>
              setQuesionData({ options: { boolean: event.target.value } })
            }
          ></textarea>
        </div>
        <div className="examsOptionComp g g2">
          <span>D</span>
          <textarea
            name="optionExams"
            id=""
            cols="30"
            rows="2"
            value={quesionData.options.boolean}
            onChange={(event) =>
              setQuesionData({ options: { boolean: event.target.value } })
            }
          ></textarea>
        </div>
        <div className="examsOptionComp g g2">
          <span>E</span>
          <textarea
            name="optionExams"
            id=""
            cols="30"
            rows="2"
            value={quesionData.options.boolean}
            onChange={(event) =>
              setQuesionData({ options: { boolean: event.target.value } })
            }
          ></textarea>
        </div>
      </div>
    );
  }
  function switchExamsOptions() {
    switch (optionType) {
      case "Boolean":
        return <ExamsOptionBoolean />;
      case "Yes or No":
        return <ExamsOptionYesorNo />;
      case "A.B.C.D & E":
        return <ExamsOption5 />;
      case "A.B.C & D":
        return <ExamsOption4 />;
      case "A.B & C":
        return <ExamsOption3 />;
      case "A & B":
        return <ExamsOption2 />;
      default:
        return <ExamsOption4 />;
    }
  }

  // Switching between the two components
  const question = quesionData.question;
  const optionBoolean = quesionData.options.boolean;
  const optionYesorNo = quesionData.options.yesOrNo;
  const alphabet2 = quesionData.options.alphabet2;
  const alphabet3 = quesionData.options.alphabet3;
  const alphabet4 = quesionData.options.alphabet4;
  const alphabet5 = quesionData.options.alphabet5;

  function getCurrentOptionValue() {
    switch (optionType) {
      case "Boolean":
        return optionBoolean;
      case "Yes or No":
        return optionYesorNo;
      case "A.B & C":
        return alphabet3;
      case "A.B.C & D":
        return alphabet4;
      case "A.B.C.D & E":
        return alphabet5;
      case "A & B":
        return alphabet2;
      default:
        return alphabet4;
    }
  }

  //   REDUX FUNCTIONS -------------------------------------------

  const data = {
    question: question,
    option: getCurrentOptionValue(),
  };

  console.log(data);

  function pushExamsQueue() {
    setLoading(true);
    dispatch(DispatchToQueue());
    setLoading(false);
  }
  const DispatchToQueue = () => async (dispatch) => {
    try {
      dispatch(Action.pushQuestion({ data }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section className="sectionExamsSetting">
      <div className="ExamSetMain fx-cl space2">
        <h4>Set up Examination Queus here</h4>
        <textarea
          name="examsQuestion"
          id="examsQueue"
          cols="30"
          rows="10"
          value={quesionData.question}
          onChange={(event) => setQuesionData({ question: event.target.value })}
        ></textarea>
        <div className="fx-jb switchExamsOption">
          <span>&nbsp;</span>
          <div className="dropdown-container">
            <button
              className="dropdown-button"
              onClick={() => setShowDropdown((prev) => !prev)}
            >
              {optionType} ▼
            </button>

            {showDropdown && (
              <ul className="dropdown-menu">
                <li
                  onClick={() => {
                    setoptionType("Boolean");
                    setShowDropdown(false);
                  }}
                >
                  Boolean
                </li>
                <li
                  onClick={() => {
                    setoptionType("Yes or No");
                    setShowDropdown(false);
                  }}
                >
                  Yes or No
                </li>
                <li
                  onClick={() => {
                    setoptionType("A & B");
                    setShowDropdown(false);
                  }}
                >
                  A & B
                </li>
                <li
                  onClick={() => {
                    setoptionType("A.B & C");
                    setShowDropdown(false);
                  }}
                >
                  A.B & C
                </li>
                <li
                  onClick={() => {
                    setoptionType("A.B.C & D");
                    setShowDropdown(false);
                  }}
                >
                  A.B.C & D
                </li>
                <li
                  onClick={() => {
                    setoptionType("A.B.C.D & E");
                    setShowDropdown(false);
                  }}
                >
                  A.B.C.D & E
                </li>
              </ul>
            )}
          </div>
        </div>

        <div className="fx-cl space2">
          {switchExamsOptions()}
          <div className="fx-jb space2">
            <div>&nbsp;</div>
            <button onClick={() => pushExamsQueue()}>Upload</button>
          </div>
        </div>
      </div>
    </section>
  );
}
